
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface FlashSubscriptionDetailsRequest extends APIRequest
{
    getMsisdn(): string;
}

export class FlashSubscriptionDetailsRequestImpl extends APIRequestDtoImpl implements FlashSubscriptionDetailsRequest
{
    constructor(private msisdn: string)
    {
        super();
    }
    getMsisdn(): string {
       return this.msisdn;
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsrequest.tsx